module.exports = __webpack_public_path__ + "media/images/emblems/Gurzelen-coat_of_arms-697fab858c7a7068278653aadbdbd260.svg";